import {
  getCurrentSkuCouponDiscounts,
  getPageType,
  getSearchDataLayerDetails,
  pushAnalyticsObjToDataLayer,
  sanitizeTextForAnalytics,
} from "@/utils/helper"
import { getPressRoomEventInfo } from "@/components/PressRoomLanding/v1/pressRoomAnalytics"
import {
  CLOSE,
  COLOR,
  IMG_ITEM_ISO,
  PRODUCT,
  PROMO_TILES,
  QUICK_VIEW,
  QUICK_VIEW_MODAL,
  SEARCH_INTERNAL_TYPE,
} from "@/constants/index"
import _get from "lodash/get"
import { COLOR_SELECTION_ID } from "@/components/Threekit/ConfigurationPannel/constants"

export const searchGetBackToTopAnalytics = type =>
  JSON.stringify({
    eventAction: `search results:${type}:main content area:back to top`,
    eventName: `search results:${type}:main content area:back to top`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "search results",
    internalLinkType: "search results:navigation",
    internalLinkZoneName: `search results:${type}:main content area`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })

export const technicalSpecGetBackToTopAnalytics = JSON.stringify({
  eventAction: "technical specs:main content area:back to top",
  eventName: "technical specs:main content area:back to top",
  eventType: "navigation",
  eventMsg: "n/a",
  eventStatus: "n/a",
  internalLinkName: "back to top",
  internalLinkPosition: "tech specs",
  internalLinkType: "technical specs:navigation",
  internalLinkZoneName: "technical specs:main content area",
  internalLinkURL: "n/a",
  clickInternalLinks: "true",
})

export const plpGetBackToTopAnalytics = JSON.stringify({
  eventAction: "plp:back to top",
  eventName: "plp:back to top",
  eventType: "navigation",
  eventMsg: "n/a",
  eventStatus: "n/a",
  internalLinkName: "back to top",
  internalLinkPosition: "plp",
  internalLinkType: "plp:navigation",
  internalLinkZoneName: "plp:promo tiles",
  internalLinkURL: "n/a",
  clickInternalLinks: "true",
})

export const defaultGetBackToTopAnalytics = JSON.stringify({
  eventAction: "support:help and faq:article list:back to top",
  eventName: "support:help and faq:article list:back to top",
  eventType: "navigation",
  eventMsg: "n/a",
  eventStatus: "n/a",
  internalLinkName: "back to top",
  internalLinkPosition: "support:help and faq",
  internalLinkType: "support:help and faq:navigation",
  internalLinkZoneName: "support:help and faq:article list",
  internalLinkURL: "n/a",
  clickInternalLinks: "true",
})

export const searchLoadMoreAnalyticsData =
  '{"eventAction":"search results:products:main content area:load more","eventName":"search results:products:main content area:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"search results","internalLinkType":"search results:load more","internalLinkZoneName":"search results:products:main content area","internalLinkURL":"n/a","clickInternalLinks":"true"}'

export const technicalSpecLoadMoreAnalyticsData =
  '{"eventAction":"technical specs:main content area:load more","eventName":"technical specs:main content area:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"tech specs","internalLinkType":"technical specs:load more","internalLinkZoneName":"technical specs:main content area","internalLinkURL":"n/a","clickInternalLinks":"true"}'

export const articleLoadMoreAnalyticsData = `{"eventAction":"support:help and faq:article list:load more","eventName":"support:help and faq:article list:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"support:help and faq","internalLinkType":"support:help and faq:load more","internalLinkZoneName":"support:help and faq:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}`
export const defaultLoadMoreAnalyticsData =
  '{"eventAction":"plp load more","eventName":"plp load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"plp","internalLinkType":"plp:load more","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}'

const generatePressReleaseAnalyticsData = (type, actionType) => {
  return `{
    "clickInternalLinks": "true",
    "eventAction": "press room:${type}:${actionType}",
    "eventMsg": "n/a",
    "eventName": "press room:${type}:${actionType}",
    "eventStatus": "n/a",
    "eventType": "navigation",
    "internalLinkName": "${actionType}",
    "internalLinkPosition": "press room",
    "internalLinkType": "press room:${actionType}",
    "internalLinkURL": "n/a",
    "internalLinkZoneName": "press room:${type}:${actionType}"
  }`
}

const getLoadMoreAnalyticsData = (page = "") => {
  let analyticsData = ""
  if (page === "search") {
    analyticsData = searchLoadMoreAnalyticsData
  } else if (page === "technicalspecs") {
    analyticsData = technicalSpecLoadMoreAnalyticsData
  } else if (page === "article") {
    analyticsData = articleLoadMoreAnalyticsData
  } else if (page === "press-release") {
    analyticsData = generatePressReleaseAnalyticsData(
      "press releases",
      "load more"
    )
  } else if (page === "press-kit") {
    analyticsData = generatePressReleaseAnalyticsData("press kit", "load more")
  } else {
    analyticsData = defaultLoadMoreAnalyticsData
  }
  return JSON.parse(analyticsData)
}

const getBackToTopAnalyticsData = (isSearchTab, page, type = "") => {
  let eventInfo = ""
  if (isSearchTab && page === "search") {
    eventInfo = searchGetBackToTopAnalytics(type)
  } else if (page === "technicalspecs") {
    eventInfo = technicalSpecGetBackToTopAnalytics
  } else if (page === "plp") {
    eventInfo = plpGetBackToTopAnalytics
  } else if (page === "press-release") {
    eventInfo = generatePressReleaseAnalyticsData(
      "press releases",
      "back to top"
    )
  } else if (page === "press-kit") {
    eventInfo = generatePressReleaseAnalyticsData("press kit", "back to top")
  } else {
    eventInfo = defaultGetBackToTopAnalytics
  }
  return JSON.parse(eventInfo)
}

export const addLoadMoreAnalytics = (page = "") => {
  const pageEvent = window.pageObj || {}
  const pageType = getPageType()

  const modifiedPageObj = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  const eventInfo = getLoadMoreAnalyticsData(page)
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", modifiedPageObj)
}

export const addSortAnalytics = selectSort => {
  const eventInfo = getSortAnalyticsData(
    selectSort,
    {
      selectSort,
      page: "plp",
    },
    "",
    true
  )
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addBackToTopAnalytics = (isSearchTab, page = "") => {
  const pageEvent = window.pageObj || {}
  const pageType = getPageType()

  const modifiedPageObj = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  const eventInfo = getBackToTopAnalyticsData(isSearchTab, page)
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", modifiedPageObj)
}

export const getAnalyticsData = (
  t,
  page,
  limit = "",
  all = false,
  selectedTab = "",
  pos = "bottom"
) => {
  limit = limit + ""
  let analyticsData = ""
  if (page === "search") {
    if (!all) {
      analyticsData = JSON.stringify({
        eventAction: `search results:${selectedTab}:main content area:pagination`,
        eventName: `search results:${selectedTab}:main content area:pagination`,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: limit,
        internalLinkPosition: "search results",
        internalLinkType: `search results:pagination ${pos}`,
        internalLinkZoneName: `search results:${selectedTab}:main content area`,
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
      })
    } else {
      analyticsData = JSON.stringify({
        eventAction: `search results:${selectedTab}:main content area:pagination`,
        eventName: `search results:${selectedTab}:main content area:pagination`,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: t("kf.plp.label.all"),
        internalLinkPosition: "search results",
        internalLinkType: `search results:pagination ${pos}`,
        internalLinkZoneName: `search results:${selectedTab}:main content area`,
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
      })
    }
  } else if (page === "technicalspecs") {
    if (!all) {
      analyticsData =
        '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' +
        limit +
        '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' +
        pos +
        '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}'
    } else {
      analyticsData =
        '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' +
        t("kf.plp.label.all") +
        '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' +
        pos +
        '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}'
    }
  } else if (page === "favorites") {
    if (!all) {
      analyticsData = JSON.stringify({
        eventAction: `my account:favorites:${selectedTab}:pagination`,
        eventName: `my account:favorites:${selectedTab}:pagination`,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: `${limit}`,
        internalLinkPosition: "favorites",
        internalLinkType: "my account:pagination bottom",
        internalLinkZoneName: `my account:favorites:${selectedTab}`,
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
      })
    } else {
      analyticsData = JSON.stringify({
        eventAction: `my account:favorites:${selectedTab}:pagination`,
        eventName: `my account:favorites:${selectedTab}:pagination`,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: `${t("kf.plp.label.all")}`,
        internalLinkPosition: "favorites",
        internalLinkType: "my account:pagination bottom",
        internalLinkZoneName: `my account:favorites:${selectedTab}`,
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
      })
    }
  } else if (page === "article") {
    analyticsData = JSON.stringify({
      eventAction: "support:help and faq:article list:pagination",
      eventName: "support:help and faq:article list:pagination",
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: !all ? limit : t("kf.plp.label.all"),
      internalLinkPosition: "knowledge articles",
      internalLinkType: "support:help and faq:pagination " + pos,
      internalLinkZoneName: "support:help and faq:article list",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    })
  } else if (page === "literature") {
    if (!all) {
      analyticsData =
        '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' +
        limit +
        '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}'
    } else {
      analyticsData =
        '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' +
        t("kf.plp.label.all") +
        '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}'
    }
  } else if (page === "press-release") {
    const type = "pagination"
    if (!all) {
      analyticsData = getPressRoomEventInfo(
        page,
        t("kf.PressRoom.label.title"),
        type,
        limit
      )
    } else {
      analyticsData = getPressRoomEventInfo(
        page,
        t("kf.PressRoom.label.title"),
        t("kf.plp.label.all"),
        type
      )
    }
  } else if (page === "press-kits") {
    if (!all) {
      analyticsData =
        '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' +
        limit +
        '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}'
    } else {
      analyticsData =
        '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' +
        t("kf.plp.label.all") +
        '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}'
    }
  } else if (page === "blog") {
    const pageCount = !all ? limit : "all"
    const category = selectedTab ? sanitizeTextForAnalytics(selectedTab) : ""
    const linkName = `view ${pageCount}`
    const blogCategory =
      category && category === "how tos" ? "how to's" : category
    const linkUrl = ""
    let resolvedLinkUrl = "n/a"
    if (linkUrl) {
      resolvedLinkUrl =
        linkUrl.indexOf("http") === -1
          ? window.location.origin + linkUrl
          : linkUrl
    }
    const eventInfo = {
      clickInternalLinks: "true",
      eventAction: `blog listing:${blogCategory}:main content area:pagination`,
      eventName: `blog listing:${blogCategory}:main content area:pagination`,
      eventType: "navigation",
      internalLinkName: linkName ? linkName : "pagination",
      internalLinkPosition: "blogs listing",
      internalLinkType: `blog listing:navigation`,
      internalLinkZoneName: `blog listing:${blogCategory}:main content area`,
      internalLinkURL: resolvedLinkUrl,
    }
    analyticsData = JSON.stringify(eventInfo)
  } else {
    const internalLinkZoneName =
      pos === "top" ? `"plp:sticky nav filter"` : `"plp:promo tiles"`
    if (!all) {
      analyticsData =
        '{"eventAction":"plp pagination ' +
        pos +
        '","eventName":"plp pagination ' +
        pos +
        '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' +
        limit +
        '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' +
        internalLinkZoneName +
        ',"internalLinkURL":"n/a","clickInternalLinks":"true"}'
    } else {
      analyticsData =
        '{"eventAction":"plp pagination ' +
        pos +
        '","eventName":"plp pagination ' +
        pos +
        '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' +
        t("kf.plp.label.all") +
        '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' +
        internalLinkZoneName +
        ',"internalLinkURL":"n/a","clickInternalLinks":"true"}'
    }
  }

  return analyticsData
}

export const getSortAnalyticsData = (
  item,
  { selectedtab, page },
  myListTitle,
  needJson = false
) => {
  const myListHeading = myListTitle?.toLowerCase()
  let analyticsData = {
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${item}`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (page === "search" && selectedtab === "technical") {
    analyticsData = {
      ...analyticsData,
      eventAction: "search results:technical:main content area:sort by",
      eventName: "search results:technical:main content area:sort by",
      internalLinkPosition: "search results",
      internalLinkType: "search results:sort by",
      internalLinkZoneName: "search results:technical:main content area",
    }
  }
  switch (page) {
    case "search":
      analyticsData = {
        ...analyticsData,
        eventAction: `search results:${selectedtab}:main content area:sort by`,
        eventName: `search results:${selectedtab}:main content area:sort by`,
        internalLinkPosition: "search results",
        internalLinkType: "search results:sort by",
        internalLinkZoneName: `search results:${selectedtab}:main content area`,
      }
      break
    case "favorites":
      analyticsData = {
        ...analyticsData,
        eventAction: `my account:${myListHeading}:${selectedtab}:sort by`,
        eventName: `my account:${myListHeading}:${selectedtab}:sort by`,
        internalLinkPosition: `my account:${myListHeading}:${selectedtab}`,
        internalLinkType: `my account:${myListHeading}:${item}`,
        internalLinkZoneName: `my account:${myListHeading}:${selectedtab}`,
      }
      break

    case "article":
      analyticsData = {
        ...analyticsData,
        eventAction: "support:help and faq:article list​:sort by",
        eventName: "support:help and faq:article list​:sort by",
        internalLinkPosition: "knowledge articles",
        internalLinkType: "support:help and faq:sort by",
        internalLinkZoneName: "support:help and faq:article list​​",
      }
      break
    case "active-services":
      analyticsData = {
        ...analyticsData,
        eventAction: "my account:services:active services​:sort by",
        eventName: "my account:services:active services​:sort by",
        internalLinkPosition: "my services",
        internalLinkType: "my account:sort by",
        internalLinkZoneName: "my account:services:active services",
      }
      break
    case "past-services":
      analyticsData = {
        ...analyticsData,
        eventAction: "my account:services:past services​:sort by",
        eventName: "my account:services:past services​:sort by",
        internalLinkPosition: "my services",
        internalLinkType: "my account:sort by",
        internalLinkZoneName: "my account:services:past services",
      }
      break
    case "literature":
      analyticsData = {
        ...analyticsData,
        eventAction: "literature:sort by",
        eventName: "literature:sort by",
        internalLinkPosition: "literature",
        internalLinkType: "literature:sort by",
        internalLinkZoneName: "literature:main content area",
      }
      break
    case "press-release":
      analyticsData = {
        ...analyticsData,
        eventAction: "press room:press releases:sort by",
        eventName: "press room:press releases:sort by",
        internalLinkPosition: "press room",
        internalLinkType: "press room:sort by",
        internalLinkZoneName: "press room:press releases:main content area",
      }
      break
    case "press-kits":
      analyticsData = {
        ...analyticsData,
        eventAction: "press room:press kits:sort by",
        eventName: "press room:press kits:sort by",
        internalLinkPosition: "press room",
        internalLinkType: "press room:sort by",
        internalLinkZoneName: "press room:press kits:main content area",
      }
      break
    case "my products":
      analyticsData = {
        ...analyticsData,
        eventAction: "my account:products:sort by filter",
        eventName: "my account:products:sort by filter",
        internalLinkPosition: "my account",
        internalLinkType: "my account:sort by",
        internalLinkZoneName: "my account:products",
      }
      break
    default:
      analyticsData = {
        ...analyticsData,
        eventAction: "plp sort by filter",
        eventName: "plp sort by filter",
        internalLinkPosition: "plp",
        internalLinkType: "plp:sort by",
        internalLinkZoneName: "plp:sort by filter",
      }
  }
  if (needJson) return analyticsData
  return JSON.stringify(analyticsData)
}

/**
 * common data layer function
 * @param {*} e
 */
export const handlePLPDataLayer = e => {
  const target = e.target.closest('[data-datalayer-id="kds-element-plp"]')
  if (target) {
    const eventInfo = JSON.parse(
      target?.attributes?.["data-datalayer-data"]?.nodeValue || "{}"
    )
    const productInfo = JSON.parse(
      target?.attributes?.["data-datalayer-data-product"]?.nodeValue || "{}"
    )

    const page = window.pageObj || {}

    window.adobeDataLayer.push({
      event: "cmp:click",
      page,
      eventInfo,
      productInfo,
    })
  }
}
const getEventBaseInfo = (prefix, type, alternameType) => {
  const actionSuffix = alternameType || type || "navigation"
  const eventNameAndAction = type.includes(QUICK_VIEW)
    ? `${prefix}:${actionSuffix}`
    : `${prefix} ${PRODUCT} ${actionSuffix}`
  return {
    eventAction: eventNameAndAction.trim(),
    eventName: eventNameAndAction.trim(),
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
  }
}

const getInternalLinkInfo = (
  prefix,
  plpPage,
  selectedTabForSearchResults,
  type
) => {
  const internalLinkType = type.includes(CLOSE)
    ? `${prefix}:${type.split(`:${CLOSE}`)[0]}`
    : `${prefix}:${type || "navigation"}`

  const zoneSuffix = plpPage
    ? PROMO_TILES
    : `${selectedTabForSearchResults}:main content area`
  return {
    internalLinkType,
    internalLinkZoneName: type.includes(QUICK_VIEW)
      ? type.includes(CLOSE)
        ? `${prefix}:${type}`
        : `${prefix}:${zoneSuffix}:${type}`
      : `${prefix}:${zoneSuffix}`,
    internalLinkPosition: plpPage
      ? type.includes(CLOSE)
        ? `${prefix}:${PROMO_TILES}:${type.split(`:${CLOSE}`)[0]}`
        : prefix
      : "search results",
  }
}

const getSkuIdParam = (color, skuCode) => {
  if (color) return `?skuId=${color.sku}`
  if (skuCode) return `?skuId=${skuCode}`
  return ""
}

const getLinkName = (type, alternameType, propsProductCard) => {
  if (type === COLOR) return COLOR_SELECTION_ID
  return (
    alternameType ||
    sanitizeTextForAnalytics(type || propsProductCard.product.productName)
  )
}

const getInternalLinkNameForType = (
  type,
  sterling,
  compareInternalLinkName
) => {
  if (sterling) return SEARCH_INTERNAL_TYPE.sterlingResults
  if (type === SEARCH_INTERNAL_TYPE.compare) return compareInternalLinkName
  if (type === SEARCH_INTERNAL_TYPE.partsDiagram)
    return SEARCH_INTERNAL_TYPE.serviceParts
  return type
}

export const getEventInfo = (
  type,
  color,
  needsJSON = false,
  isForSample = false,
  sterling = false,
  message = "",
  isChecked = false,
  propsProductCard,
  index,
  internalLinkName = "",
  internalLinkURLVal = ""
) => {
  const fullUrl = propsProductCard.fullUrl
  const skuCode = propsProductCard.product.sku
  const productCollectionsName =
    propsProductCard?.product?.productCollectionsName
  // Setup basic variables
  const plpPage = true
  const prefix = isForSample ? "plp:sample" : "plp"
  const selectedTabForSearchResults = type || "products"

  // Get alternate type and compare status
  let alternameType = ""
  if (type === "favorite") {
    alternameType = message.includes("removed")
      ? "favorite remove"
      : "favorite add"
  } else if (type === "compare") {
    alternameType = isChecked ? "compare add" : "compare remove"
  }

  let compareInternalLinkName = ""
  if (type === "compare") {
    compareInternalLinkName = isChecked ? "add to compare" : "remove compare"
  }

  // Get internal link URL
  const skuIdParam = getSkuIdParam(color, skuCode)

  const internalLinkURL =
    internalLinkURLVal || (!type ? `${fullUrl}${skuIdParam}` : "n/a")

  // Build event info object
  const baseEventInfo = getEventBaseInfo(prefix, type, alternameType)
  const linkInfo = getInternalLinkInfo(
    prefix,
    plpPage,
    selectedTabForSearchResults,
    type
  )
  const linkName = getLinkName(type, alternameType, propsProductCard)

  let eventInfo = {
    ...baseEventInfo,
    ...linkInfo,
    productGridPosition: index + 1,
    internalLinkName: type
      ? [QUICK_VIEW, CLOSE].every(val => type.includes(val))
        ? `${CLOSE}`
        : getInternalLinkNameForType(
            linkName,
            sterling,
            compareInternalLinkName
          )
      : productCollectionsName,
    internalLinkURL:
      internalLinkURLVal ||
      (propsProductCard.product.isSterling && typeof window !== "undefined"
        ? window.location.href
        : internalLinkURL),
    clickInternalLinks: "true",
    ...getSearchDataLayerDetails({}),
  }
  if (type.includes(QUICK_VIEW)) {
    eventInfo.modalName = QUICK_VIEW_MODAL
  }
  // Override event type for samples/favorites
  if (isForSample || type === "favorite") {
    eventInfo.eventType = "wishlist save"
  }
  if (type === "share") {
    eventInfo = {
      ...eventInfo,
      eventAction: "plp product share",
      eventName: "plp product share",
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkPosition: "plp",
      internalLinkType: "plp:share",
      internalLinkZoneName: "plp:promo tiles",
      clickInternalLinks: "false",
      internalLinkName: internalLinkName || "share",
    }
  }

  return needsJSON ? eventInfo : JSON.stringify(eventInfo)
}

const getColorDetails = (color, data) => {
  const colorDetail = data[`Color.SKU.Details_ss`] ?? []
  const colorInfo = color
    ? colorDetail.find(item => item.split("|")[2] === color.sku)
    : null
  return {
    colorName: colorInfo?.split("|")[0] ?? "",
    inStock: colorInfo?.split("|")[3] ?? "",
  }
}

const getDescription = (data, isGrouped) => {
  return isGrouped
    ? _get(data, "Collapse_Description_s", "")
    : _get(data, "ProductDescriptionProductShort_s", "")
}

const getProductId = (color, data, sterling, propsProductCard, skuPrepend) => {
  const sterlingData = []
  if (sterling && sterlingData.length) {
    return sterlingData[0]?.sku_s ?? ""
  }
  return (
    color?.customerFacingSKU ||
    propsProductCard.customerFacingSKU ||
    data["masterCustomerFacingSKU_s"] ||
    `${skuPrepend.toLowerCase()}${data?.masterSKU_s}` ||
    "n/a"
  )
}

const getBaseProductInfo = (
  description,
  category,
  productRoom,
  general,
  propsProductCard
) => {
  const datalayerProductRoom =
    productRoom === "n/a" || productRoom === undefined ? category : productRoom
  return {
    productBrand: general?.siteName?.toLowerCase(),
    description: sanitizeTextForAnalytics(description) || "n/a",
    globalPromotionPrice:
      propsProductCard.product.globalPromotionPrice || "n/a",
    priceState: propsProductCard.product.priceState || "regular price",
    productBasePrice: propsProductCard.product.productBasePrice || "n/a",
    productCategory: sanitizeTextForAnalytics(category) || "n/a",
    productRoom: sanitizeTextForAnalytics(datalayerProductRoom) || "n/a",
    productSalePrice: propsProductCard.product.productSalePrice || "n/a",
    productSaleable: !!propsProductCard.product.productSaleable,
  }
}

const getProductStatus = (color, inStock, propsProductCard) => {
  if (color) {
    return inStock === "true" || inStock === true ? "in stock" : "out of stock"
  }
  return propsProductCard.product.productStatus ? "in stock" : "out of stock"
}

export const getProductInfo = (
  color = "",
  needsJSON = false,
  sterling = false,
  cartData,
  propsProductCard,
  locale,
  skuPrepend,
  general
) => {
  const skuCode = propsProductCard.product.sku
  const { productCouponCode, productCoupondiscount } =
    getCurrentSkuCouponDiscounts({
      cart: cartData,
      sku: skuCode,
      locale: locale,
    })

  const data = propsProductCard.originaldata
  const { colorName, inStock } = getColorDetails(color, data)
  const description = getDescription(data, propsProductCard.isGrouped)
  const productId = getProductId(
    color,
    data,
    sterling,
    propsProductCard,
    skuPrepend
  )
  const category = propsProductCard.product.category
  const productRoom = _get(data, "category1_s", "n/a")

  const baseInfo = getBaseProductInfo(
    description,
    category,
    productRoom,
    general,
    propsProductCard
  )
  const product = propsProductCard.product

  const productInfo = {
    productInfo: {
      ...baseInfo,
      productBrand: sterling ? "sterling" : baseInfo.productBrand,
      productColor:
        sanitizeTextForAnalytics(colorName || product.productColor) || "n/a",
      productID: productId,
      productName:
        product.productName || sanitizeTextForAnalytics(description) || "n/a",
      productStatus: getProductStatus(color, inStock, propsProductCard),
      productSuperSku: product.isSuperSku,
      productTileName: product.productTileName || "n/a",
      defaultImageName: propsProductCard.defaultImageName || "n/a",
      productCollectionsName: sanitizeTextForAnalytics(
        category || product.productCollectionsName
      ),
      globalOffer: product.badgeValue || "n/a",
      globalDiscount: product.discountPercent ? product.discountAmount : "n/a",
      productPartnerBuyNow: product.productIsRetail,
      pdpType: product.isBundleProduct
        ? "bundle"
        : "regular finished goods & service parts",
      productCouponCode: productCouponCode.join("|") || "n/a",
      productCoupondiscount,
      productFindingMethod: "n/a",
      frequency: "n/a",
      isRecommended: "n/a",
      isSendNow: "n/a",
      isSubscription: "n/a",
      quantity: "n/a",
      ratings: "n/a",
      numberOfReviews: "n/a",
    },
  }

  return needsJSON ? productInfo.productInfo : JSON.stringify(productInfo)
}

export const colorDataLayerHandle = (
  propsProductCard,
  index,
  cartData,
  locale,
  skuPrepend,
  general,
  type = null,
  internalLinkName = "",
  internalLinkURL = ""
) => {
  const page = window.pageObj || {}
  const eventInfo = getEventInfo(
    type,
    propsProductCard.product,
    true,
    false,
    false,
    "",
    false,
    propsProductCard,
    index,
    internalLinkName,
    internalLinkURL
  )
  const productInfo = getProductInfo(
    propsProductCard.product,
    true,
    false,
    cartData,
    propsProductCard,
    locale,
    skuPrepend,
    general
  )
  if (type.includes(QUICK_VIEW)) {
    productInfo.category = productInfo["productCategory"] || "n/a"
    productInfo.itemType = PRODUCT
    productInfo.waterSenseProduct =
      propsProductCard.originaldata["ProductWaterSense_ss"] || false
    const defaultImage =
      productInfo?.defaultImageName &&
      productInfo.defaultImageName.includes("PAWEB")
        ? productInfo?.defaultImageName?.split("PAWEB/")[0]
        : "n/a"
    page.pageInfo.defaultImage = defaultImage
    page.pageInfo.imageId = defaultImage
    page.pageInfo.resourceType = IMG_ITEM_ISO
  }
  const pageType = getPageType()
  page.pageInfo.contentType = pageType
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
    productInfo,
  })
}

export const dataLayerPush = (
  message,
  status,
  type,
  isChecked,
  propsProductCard,
  index,
  cartData,
  locale,
  skuPrepend,
  general
) => {
  const page = window.pageObj || {}
  const pageType = getPageType()
  page.pageInfo.contentType = pageType
  let isForSample = false
  if (page && page?.category?.subCategory1) {
    const {
      category: { subCategory1 },
    } = page
    isForSample = subCategory1.includes("samples")
  }
  const eventInfo = getEventInfo(
    type,
    null,
    true,
    isForSample,
    "",
    message,
    isChecked,
    propsProductCard,
    index
  )
  const productInfo = getProductInfo(
    "",
    true,
    false,
    cartData,
    propsProductCard,
    locale,
    skuPrepend,
    general
  )
  eventInfo.eventStatus = status
  eventInfo.eventMsg = sanitizeTextForAnalytics(message)
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
    productInfo,
  })
}

export const removeProductFromListDataLayerPush = (eventType, productInfo) => {
  const pageEvent = window.pageObj || {}
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `plp:product details:${eventType}`,
    eventMsg: "n/a",
    eventName: `plp:product details:${eventType}`,
    eventStatus: "n/a",
    eventType: `wishlist ${
      eventType === "delete from list" ? "delete" : "save"
    }`,
    internalLinkName: eventType,
    internalLinkPosition: "plp",
    internalLinkType: eventType,
    internalLinkURL: "n/a",
    internalLinkZoneName: eventType,
  }
  window.adobeDataLayer.push({
    event: "cmp:click",
    page: pageEvent,
    eventInfo,
    productInfo,
  })
}

export const getPLPPaginationAnalyticsData = currentPerPage => {
  const pageEvent = window.pageObj || {}
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "plp pagination bottom",
    eventMsg: "n/a",
    eventName: "plp pagination bottom",
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: `${currentPerPage}`,
    internalLinkPosition: "plp",
    internalLinkType: "plp:pagination",
    internalLinkURL: "n/a",
    internalLinkZoneName: "plp:promo tiles",
  }
  const pageType = getPageType()

  const updatedPageEvent = {
    ...pageEvent,
    pageInfo: {
      ...(pageEvent.pageInfo || {}),
      contentType: pageType,
    },
  }
  window.adobeDataLayer.push({
    event: "cmp:click",
    page: updatedPageEvent,
    eventInfo,
  })
}
